module.exports = __webpack_public_path__ + "img/ap2020-watermark-cn.eb7e446.png";